const pageUnity = {
  mountVideoIframe: () => {
    $(".unit__block-pictures--thumbnail-video").on("click", function (e) {
      e.preventDefault();
      const iframeURL = $(this).find("iframe").attr("src");
      $(".unity-video__iframe").find("iframe").attr("src", iframeURL);
      $(".unity-video").fadeIn().css({ display: "flex" });
      console.log(iframeURL);
    });
  },
  removeOverlay: () => {
    $(".unity-video__overlay").on("click", function () {
      $(".unity-video").fadeOut();
    });
  },
  unitysSelection: () => {
    $(".units-select").on("change", function () {
      const element = $(this);
      const selected = element.val();
      window.location.href = selected;
    });
  },
  zoomImage: () => {
    $(".zoomImage").on("click", function () {
      const element = $(this);
      const background = element.attr("data-image");
      $(".zoomImageContainer").remove();
      $("body").append(
        `<div class="zoomImageContainer"><div class="zoomImageContainer__overlay"></div><div class="zoomImageContainer__container"><button class="zoomImageContainer__close">+</button><img src="${background}"/></div></div>`
      );
      $(".zoomImageContainer").fadeIn();
    });
  },
  zoomClose: () => {
    $("body").on(
      "click",
      ".zoomImageContainer__close, .zoomImageContainer__overlay",
      function () {
        $(".zoomImageContainer").fadeOut();
      }
    );
  },
  init: () => {
    pageUnity.mountVideoIframe();
    pageUnity.removeOverlay();
    pageUnity.unitysSelection();
    pageUnity.zoomImage();
    pageUnity.zoomClose();
  },
};

export default pageUnity;
